// ** React Imports
import { useContext } from "react";

// ** Custom Components
import Block from "components/layout/Block";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// #####################################################

export const NearbyFilters = ({
	setFiltersOpen,
	renderLocationSelector,
	renderMultipleSexSelector,
}) => {
	const { isPhone } = useContext(deviceTypeContext);

	// #####################################################

	return (
		<Block
			mt={3}
			flex
			fullWidth={isPhone}
			column={isPhone}
			flexWrap
			withRowGap
		>
			{renderMultipleSexSelector(setFiltersOpen)}
			{renderLocationSelector(setFiltersOpen)}
		</Block>
	);
};

// #####################################################
